export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-sky-50 border-t border-sky-100">
      <div className="max-w-6xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-10">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2.5 mb-3">
              <div className="relative w-9 h-9 flex items-center justify-center shrink-0">
                <svg width="36" height="36" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="50" cy="50" r="48" fill="url(#footerGrad)" />
                  <defs>
                    <linearGradient id="footerGrad" x1="0" y1="0" x2="100" y2="100" gradientUnits="userSpaceOnUse">
                      <stop offset="0%" stopColor="#38bdf8" />
                      <stop offset="100%" stopColor="#06b6d4" />
                    </linearGradient>
                    <linearGradient id="footerWater" x1="50" y1="22" x2="50" y2="60" gradientUnits="userSpaceOnUse">
                      <stop offset="0%" stopColor="#e0f7ff" />
                      <stop offset="100%" stopColor="#7dd3fc" />
                    </linearGradient>
                  </defs>
                  <path
                    d="M14 68 C14 68 12 58 16 52 C18 48 22 47 25 49 L27 44 C29 40 33 39 36 42 L37 39 C39 35 43 35 45 39 L46 42 C47 38 51 37 53 41 L54 38 C56 34 61 35 62 40 L64 48 C66 44 70 44 71 50 L72 60 C73 66 70 72 65 74 L40 74 C28 74 15 72 14 68 Z"
                    fill="white"
                    fillOpacity="0.95"
                  />
                  <path
                    d="M50 22 C50 22 44 32 44 40 C44 46 46.5 50 50 50 C53.5 50 56 46 56 40 C56 32 50 22 50 22 Z"
                    fill="url(#footerWater)"
                    opacity="0.9"
                  />
                  <path d="M32 60 Q50 55 68 60" stroke="#bae6fd" strokeWidth="1.5" strokeLinecap="round" fill="none" opacity="0.7"/>
                </svg>
              </div>
              <div className="flex flex-col leading-none">
                <span className="font-bold text-sm tracking-tight text-gray-900">Pure<span className="text-sky-500">Care</span></span>
                <span className="text-gray-400 text-[9px] tracking-widest uppercase font-medium">Assisted Living</span>
              </div>
            </div>
            <p className="text-gray-500 text-xs leading-relaxed max-w-xs">
              Providing compassionate, personalized care for seniors in Eden Prairie, Minnesota. Your loved one deserves the best.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-gray-700 mb-4">
              <a href="#nav">Quick Links</a>
            </h4>
            <ul className="space-y-2">
              {[
                { label: 'Home', id: 'hero' },
                { label: 'Our Services', id: 'services' },
                { label: 'Contact Us', id: 'contact' },
              ].map((link) => (
                <li key={link.id}>
                  <button
                    onClick={() => scrollTo(link.id)}
                    className="text-xs text-gray-500 hover:text-sky-600 transition-colors cursor-pointer underline whitespace-nowrap text-left"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-gray-700 mb-4">
              <a href="#contact">Contact</a>
            </h4>
            <div className="space-y-2">
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-line text-sky-500 text-xs"></i>
                </div>
                <a href="tel:6127351448" className="text-xs text-gray-500 hover:text-sky-600 transition-colors">(612) 735-1448</a>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line text-sky-500 text-xs"></i>
                </div>
                <a href="mailto:PureCareassisted@gmail.com" className="text-xs text-gray-500 hover:text-sky-600 transition-colors">PureCareassisted@gmail.com</a>
              </div>
              <div className="flex items-start gap-2">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-line text-sky-500 text-xs"></i>
                </div>
                <span className="text-xs text-gray-500 leading-relaxed">7340 Scot Terrace,<br />Eden Prairie, Minnesota</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-time-line text-sky-500 text-xs"></i>
                </div>
                <span className="text-xs text-gray-500">Open 24/7</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-sky-100 pt-6 flex flex-col sm:flex-row justify-between items-center gap-2">
          <p className="text-xs text-gray-400">
            &copy; {new Date().getFullYear()} Pure Care Assisted Living. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-gray-400 hover:text-sky-600 underline whitespace-nowrap" rel="nofollow">Privacy Policy</a>
            <a href="#" className="text-xs text-gray-400 hover:text-sky-600 underline whitespace-nowrap" rel="nofollow">Terms of Use</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
